import { render, staticRenderFns } from "./edit-desc.vue?vue&type=template&id=1b2f5149&scoped=true&"
import script from "./edit-desc.vue?vue&type=script&lang=js&"
export * from "./edit-desc.vue?vue&type=script&lang=js&"
import style0 from "./edit-desc.vue?vue&type=style&index=0&id=1b2f5149&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b2f5149",
  null
  
)

export default component.exports